import { Controller } from '@hotwired/stimulus';

export default class ApexChartsValueController extends Controller {
  static targets = ['chart'];
  static values = {
    seriesData: Array,
    seriesNames: Array,
    yaxisTitle: String,
    chartType: { type: String, default: 'area' },
    colors: { type: Array, default: ['#008FFB', '#FF4560'] },
    strokeWidth: { type: Array, default: [3, 2] },
    markers: { type: Object, default: { size: 1, strokeWidth: 1 } },
    fillType: { type: Array, default: ['gradient', 'solid'] },
  };

  connect() {
    // Build series from data
    const series = this.seriesDataValue.map((data, index) => {
      const seriesObj = { data };
      if (this.seriesNamesValue && this.seriesNamesValue[index]) {
        seriesObj.name = this.seriesNamesValue[index];
      }
      // Set type for multi-type series (area + line)
      if (index === 0) {
        seriesObj.type = 'area';
      } else if (index === 1) {
        seriesObj.type = 'line';
      }
      return seriesObj;
    });

    const minWidth = 105;

    const options = {
      chart: {
        id: 'value',
        group: 'charts',
        type: this.chartTypeValue,
        height: 240,
        toolbar: {
          show: true,
          tools: {
            download: true,
            selection: false,
            zoom: false,
            zoomin: false,
            zoomout: false,
            pan: false,
            reset: false,
          },
        },
        animations: {
          enabled: false,
        },
      },
      dataLabels: {
        enabled: false,
      },
      grid: {
        row: {
          colors: ['transparent', 'transparent'],
          opacity: 0.2,
        },
        borderColor: '#f1f3fa',
      },
      xaxis: {
        type: 'datetime',
        labels: {
          datetimeFormatter: {
            year: 'yyyy',
            month: 'MMM',
            day: 'dd MMM',
            hour: 'HH:mm',
          },
        },
      },
      tooltip: {
        x: {
          formatter: function (n) {
            let d = new Date(n);
            return new Date(
              d.getFullYear(),
              d.getMonth(),
              d.getDate(),
            ).toLocaleDateString(document.documentElement.lang);
          },
        },
      },
      colors: this.colorsValue,
      markers: this.markersValue,
      stroke: {
        width: this.strokeWidthValue,
        curve: 'smooth',
      },
      series: series,
      yaxis: {
        forceNiceScale: true,
        labels: {
          minWidth: minWidth,
          formatter: function (val) {
            if (val !== undefined) {
              return val.toLocaleString(document.documentElement.lang) + ' €';
            }
          },
        },
        title: {
          text: this.yaxisTitleValue,
        },
        min: function (n) {
          if (n < 0) {
            n = 0;
          }
          return n;
        },
      },
      fill: {
        type: this.fillTypeValue,
        gradient: {
          shadeIntensity: 1,
          opacityFrom: 0.7,
          opacityTo: 0.9,
          stops: [0, 95, 100],
        },
      },
    };

    this.chart = new ApexCharts(this.chartTarget, options);
    this.chart.render();
  }

  disconnect() {
    if (this.chart) {
      this.chart.destroy();
    }
  }
}
